import { deleteData, getData, postData, postFormData } from './config/ApiCalls';

import { apiSettings } from '../Settings';

export const sendChat = async (data) => {
  try {
    const response = await postFormData(
      `${apiSettings.chats.sendChat()}`,
      data
    );
    return response;
  } catch (error) {
    return null;
  }
};

export const getChatsList = async (page = 1) => {
  try {
    const response = await getData(`${apiSettings.chats.getChatsList(page)}`);
    return response;
  } catch (error) {
    return null;
  }
};
export const getChatsDetail = async (id = '') => {
  try {
    const response = await getData(`${apiSettings.chats.getChatsDetail(id)}`);
    return response;
  } catch (error) {
    return null;
  }
};

export const getChatsByTender = async (id = '') => {
  try {
    const response = await getData(`${apiSettings.chats.getChatsByTender(id)}`);
    return response;
  } catch (error) {
    return null;
  }
};
